<div class="loader-backdrop">
  <span class="loader"></span>
</div>
